import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'tss-react/mui';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from 'src/components/ModalDialog/index';
import EnableCPTextingForm from 'src/containers/EnableCPTexting/EnableCPTextingForm';
import enableCPTextingStyle from 'src/containers/EnableCPTexting/enableCPTexting.style';
import Spinner from 'src/components/Spinner/Spinner';
import { dismissEnableCPTexting } from 'src/actions/accountActions';

function EnableCPTexting({
  classes,
}) {
  const dispatch = useDispatch();
  const [isConfirmed, setIsConfirmed] = React.useState(false);

  const {
    enableCPTexting,
    enableCPTextingLoading: loading,
  } = useSelector((state) => state.account) || {};

  const okButtonProps = {
    form: 'formEnableCPTexting',
    type: 'primary',
    disabled: loading || !isConfirmed,
  };

  const handleCloseModal = () => {
    dispatch(dismissEnableCPTexting());
  };

  return enableCPTexting && (
    <>
      <ModalDialog
        title="Activate Connection Point Texting"
        onClose={handleCloseModal}
        onOk={() => { }}
        okButtonProps={okButtonProps}
        content={(
          <EnableCPTextingForm
            classes={classes}
            loading={loading}
            onConfirmationChange={setIsConfirmed}
          />
        )}
        closeText="Not Ready Yet"
        okText="Activate CP Texting"
        loading={loading}
        isCloseIconHid
        isVisible
        closeOnClickOnlyTheButton
      />
      <Spinner
        loading={loading}
        positionType="absolute"
      />
    </>
  );
}

EnableCPTexting.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(EnableCPTexting, enableCPTextingStyle);
